<div class="w-full flex flex-col gap-lg px-lg">
    <div class="flex flex-col gap-lg items-start self-stretch">
        <div class="flex items-center gap-4">
            <span class="text-lg font-semibold text-text-primary">{{ displayName }}</span>
            <button
                hlmBtn
                variant="link"
                type="button"
                (click)="onLogout()"
                class="text-primary-dark text-md font-normal underline p-0 h-auto"
            >
                Not you?
            </button>
        </div>

        <div class="text-lg font-semibold text-text-primary">Select a Pet</div>
    </div>

    <form [formGroup]="formGroup" class="flex flex-col gap-4">
        <hlm-radio-group formControlName="petList" class="flex flex-col gap-4">
            <div *ngFor="let pet of pets; let i = index" class="flex items-center gap-2">
                <hlm-radio [value]="pet.name" [id]="'pet-' + i">
                    <hlm-radio-indicator indicator class="w-4 h-4 border-2 border-gray-400 rounded-full"></hlm-radio-indicator>
                </hlm-radio>

                <div class="flex flex-col">
                    <label hlmLabel [for]="'pet-' + i" class="text-md font-normal text-text-primary cursor-pointer">
                        {{ pet.name }}
                    </label>

                    <div class="text-sm font-normal text-text-secondary">
                        <span *ngIf="pet.petType && pet.petType.name">{{ pet.petType.name }}</span>
                        <span *ngIf="pet.petType && pet.petType.name && (pet.petBreed?.name || pet.petType.petBreedList?.[0]?.name)">
                            |
                        </span>
                        <span *ngIf="pet.petBreed?.name || pet.petType?.petBreedList?.[0]?.name">
                            {{ pet.petBreed?.name || pet.petType?.petBreedList?.[0]?.name }}
                        </span>
                    </div>
                </div>
            </div>
        </hlm-radio-group>

        <button
            hlmBtn
            variant="link"
            type="button"
            (click)="addPet()"
            class="text-primary-dark text-md font-normal justify-start p-0 h-auto no-underline"
        >
            + Add A Pet
        </button>
    </form>
</div>
